import { create } from 'zustand';
import type { CurrentUser } from '@/types';

interface AuthState {
  user: CurrentUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  /** Jetons et profil sont conservés en mémoire uniquement (brief sécurité :
   *  aucune donnée sensible en localStorage). Un rechargement de page nécessite
   *  une nouvelle authentification. */
  isAuthenticated: boolean;
  setSession: (payload: { user: CurrentUser; accessToken: string; refreshToken: string }) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  setUser: (user: CurrentUser) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
  setSession: ({ user, accessToken, refreshToken }) =>
    set({ user, accessToken, refreshToken, isAuthenticated: true }),
  setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
  setUser: (user) => set({ user }),
  clearSession: () =>
    set({ user: null, accessToken: null, refreshToken: null, isAuthenticated: false }),
}));
